import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const FilterControls = ({ filters, onFilterChange, onExport }) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Vandaag' },
    { value: 'week', label: 'Deze Week' },
    { value: 'month', label: 'Deze Maand' },
    { value: 'quarter', label: 'Dit Kwartaal' },
    { value: 'year', label: 'Dit Jaar' },
    { value: 'all', label: 'Alle Tijd' }
  ];

  const referralTypeOptions = [
    { value: 'all', label: 'Alle Types' },
    { value: 'job', label: 'Opdrachten' },
    { value: 'contractor', label: 'Contractors' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Alle Statussen' },
    { value: 'open', label: 'Open' },
    { value: 'ongoing', label: 'Bezig' },
    { value: 'completed', label: 'Voltooid' },
    { value: 'active', label: 'Actief' },
    { value: 'inactive', label: 'Inactief' }
  ];

  const sortOptions = [
    { value: 'date-desc', label: 'Nieuwste Eerst' },
    { value: 'date-asc', label: 'Oudste Eerst' },
    { value: 'commission-desc', label: 'Hoogste Commissie' },
    { value: 'commission-asc', label: 'Laagste Commissie' }
  ];

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-5 mb-6"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-4">
        <Select
          label="Periode"
          options={dateRangeOptions}
          value={filters?.dateRange}
          onChange={(value) => onFilterChange('dateRange', value)}
        />
        <Select
          label="Type Referral"
          options={referralTypeOptions}
          value={filters?.referralType}
          onChange={(value) => onFilterChange('referralType', value)}
        />
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
        <Select
          label="Sorteren Op"
          options={sortOptions}
          value={filters?.sortBy}
          onChange={(value) => onFilterChange('sortBy', value)}
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button 
          variant="outline" 
          iconName="Download" 
          iconPosition="left"
          onClick={onExport}
          fullWidth
          className="sm:w-auto"
        >
          Rapport Downloaden
        </Button>
        <Button 
          variant="ghost" 
          iconName="RotateCcw" 
          iconPosition="left"
          onClick={() => onFilterChange('reset')}
          fullWidth
          className="sm:w-auto"
        >
          Filters Resetten
        </Button>
      </div>
    </div>
  );
};

export default FilterControls;